
export const products = {
  // Main Products Page
  mainHero: {
    title: "Our Products",
    subtitle: "Discover our premium selection of coffee, tea, and beverage solutions"
  },
  
  // Coffee Section
  coffee: {
    title: "ROASTED COFFEE",
    description: "Premium roasted coffee beans sourced from the finest origins",
    button: "Explore Coffee"
  },
  
  // Milkshakes Section
  milkshakes: {
    title: "MILKSHAKES",
    description: "Delicious and creamy milkshake mixes for every taste",
    button: "Explore Milkshakes"
  },
  
  // HoReCa Section
  horeca: {
    title: "HORECA SOLUTIONS",
    description: "Professional products for hotels, restaurants, and cafés",
    button: "Explore HoReCa"
  },
  
  // Tea Section
  tea: {
    title: "TEA",
    description: "Premium tea selection",
    button: "Explore Tea",
    comingSoon: "Coming Soon"
  },
  
  // Machines Section
  machines: {
    title: "COFFEE & TEA MACHINES",
    description: "Professional brewing equipment",
    button: "Explore Machines",
    comingSoon: "Coming Soon"
  },
  
  // Roasted Coffee Page
  roastedCoffee: {
    hero: {
      title: "Roasted Coffee",
      subtitle: "Premium coffee beans roasted to perfection",
      label: "COFFEE COLLECTION"
    },
    intro: {
      title: "Artisan Roasted Excellence",
      description: "Our roasted coffee collection represents the pinnacle of coffee craftsmanship. Each bean is carefully selected from the world's finest coffee-growing regions and roasted to perfection, bringing out unique flavor profiles that coffee enthusiasts cherish."
    },
    seeDetails: "See Details"
  },
  
  // Pods Page
  pods: {
    hero: {
      title: "Coffee Pods",
      subtitle: "Convenient single-serve coffee solutions",
      label: "ESE 44MM PODS"
    },
    intro: {
      title: "Perfect Coffee, Every Time",
      description: "Our coffee pods deliver consistent quality and convenience. Each pod is carefully crafted to preserve the rich flavors and aromas of freshly roasted coffee, making it easy to enjoy a perfect cup every time."
    },
    seeDetails: "See Details"
  },
  
  // Capsules Page
  capsules: {
    hero: {
      title: "Compatible Capsules",
      subtitle: "Premium capsules for your coffee machine",
      label: "COMPATIBLE CAPSULES"
    },
    intro: {
      title: "Compatibility Meets Quality",
      description: "Our compatible capsules are designed to work seamlessly with popular coffee machines while delivering exceptional taste. Experience premium coffee without compromise."
    },
    seeDetails: "See Details"
  },
  
  // Milkshakes Page
  milkshakesPage: {
    hero: {
      title: "Milkshakes",
      subtitle: "Creamy and delicious milkshake mixes",
      label: "MILKSHAKE COLLECTION"
    },
    intro: {
      title: "Indulgent Milkshake Experience",
      description: "Our milkshake collection offers a variety of rich, creamy flavors that delight customers of all ages. Perfect for cafés, restaurants, and ice cream parlors."
    },
    seeDetails: "See Details"
  },
  
  // HoReCa Page
  horecaPage: {
    hero: {
      title: "HoReCa Solutions",
      subtitle: "Professional products for the hospitality industry",
      label: "PROFESSIONAL SOLUTIONS"
    },
    intro: {
      title: "Elevate Your Culinary Creations",
      description: "Our HoReCa range is specifically designed for professional use in hotels, restaurants, and cafés. From pralines to sauces, each product meets the highest standards of quality and consistency."
    },
    categories: {
      pralines: "Pralines",
      fillingCreams: "Filling Creams",
      fillingFruits: "Filling Fruits",
      toppingSauces: "Topping Sauces",
      decorSauces: "Decor Sauces",
      coldGlazes: "Cold Glazes",
      coffeeBarSauces: "Coffee Bar Sauces"
    },
    seeDetails: "See Details"
  },
  
  // Tea Page
  teaPage: {
    hero: {
      title: "Premium Tea Collection",
      subtitle: "Coming Soon",
      label: "TEA COLLECTION"
    },
    comingSoonText: "A new chapter in refined taste",
    description: "We are crafting an exceptional tea collection that honors tradition while embracing innovation. Stay tuned for something extraordinary."
  },
  
  // Machines Page
  machinesPage: {
    hero: {
      title: "Coffee & Tea Machines",
      subtitle: "Coming Soon",
      label: "EQUIPMENT"
    },
    comingSoonText: "Professional equipment for excellence",
    description: "We are curating a selection of premium coffee and tea machines designed for professionals who demand perfection in every cup."
  }
};
